export const periodDescription = `
    Выбор периода регистрации. 
    <a href="https://doc.scananalytics.ru/otchety/period-otcheta-i-rezhim-s-uchetom-vremeni/" rel="noopener noreferrer" target="_blank">Подробнее</a>.
`;
export const detailsDescription = `В отчёте: Мои отчёты, данные в графике можно детализировать по:
    <br>
    - дням;<br>
    - неделям;<br>
    - дням недели;<br>
    - месяцам;<br>
    - кварталам;<br>
    - годам.<br>
    <br>
    В отчёте: Качество вебинара детализация по:<br>
    - 1 минуте;<br>
    - 5 минут;<br>
    - 15 минут.<br>
    <br>
    Если выбран большой период, то детализация графика автоматически укрупнится, чтобы отчёт быстрее сформировался.
    <br><br>
    <a href="https://doc.scananalytics.ru/otchety/detalizaciya-grafika/" rel="noopener noreferrer" target="_blank">Подробнее</a>.
`;
export const compareDescription = `
    Можно сравнить друг с другом визуально на графике и по значениям в таблице 2 разных сегмента или 2 разных периода. 
    <a href="https://doc.scananalytics.ru/otchety/sravnenie-periodov-i-segmentov/" rel="noopener noreferrer" target="_blank">Подробнее</a>.
`;

export const segmentDescription = `
    Сегменты — это набор параметров фильтра. Вы можете сохранить сотни сегментов и в 2 клика открывать нужные наборы фильтра, не тратя время на выбор одних и тех же параметров фильтра. Сегменты сохраняются за пользователем сервиса. Для каждого сотрудника будет свой индивидуальный набор сегментов. Сохранённые сегменты коллеги посмотреть нельзя. <a href="https://doc.scananalytics.ru/otchety/segmenty-i-voronki/#%D1%81%D0%B5%D0%B3%D0%BC%D0%B5%D0%BD%D1%82%D1%8B" rel="noopener noreferrer" target="_blank">Подробнее</a>.
    <br><br>
    По работе с фильтрами описано <a href="https://doc.scananalytics.ru/otchety/filtry/" rel="noopener noreferrer" target="_blank">здесь</a>.
`;
export const funnelDescription = 'Администраторы сервиса могут сохранить наборы фильтров под каждую воронку продаж. Выбор воронок продаж будет доступен всем сотрудникам и во всех отчётах. Можно выбрать одну воронку продаж или сразу несколько. <a href="https://doc.scananalytics.ru/otchety/segmenty-i-voronki/" rel="noopener noreferrer" target="_blank">Подробнее</a>.';

export const chartDescription =
  'На график можно вывести данные любой метрики и посмотреть её изменение за отчётный период с разными детализациями. В разделе Мои отчёты 5 типов графиков. На график можно выводить по несколько метрик и несколько группировок, чтобы увидеть зависимости. <a href="https://doc.scananalytics.ru/otchety/grafik-tipy-osi-legenda/" rel="noopener noreferrer" target="_blank">Подробнее</a>.';

export const trendDescription = `
<b>Тренд и среднее</b> — инструменты для анализа динамики метрик на графике. Помогают увидеть общее направление изменений и отделить случайные колебания от устойчивых тенденций.
<br><br>
<b>Типы трендов:</b>
<br><br>
<b>📈 Линейный тренд</b> — прямая линия, показывающая общее направление: рост или спад. Рядом с линией отображается процент изменения за период. Используйте, чтобы быстро понять — метрика растёт или падает.
<br><br>
<b>📉 Скользящее среднее (MA)</b> — сглаженная кривая, которая убирает ежедневные скачки и показывает плавную динамику. Доступны варианты:
<br>• <b>MA (авто)</b> — период сглаживания выбирается автоматически в зависимости от количества данных;
<br>• <b>MA (7)</b> — среднее за 7 точек (например, неделя);
<br>• <b>MA (14)</b> — среднее за 14 точек;
<br>• <b>MA (30)</b> — среднее за 30 точек.
<br>Чем больше период — тем более сглаженная линия. Удобно для выявления долгосрочных тенденций.
<br><br>
<b>➖ Среднее значение</b> — горизонтальная пунктирная линия на уровне среднего арифметического за весь период. Рядом отображается числовое значение. Используйте, чтобы видеть, в какие дни метрика была выше или ниже нормы.
<br><br>
<b>Как пользоваться:</b>
<br><br>
1. <b>Глобальное включение</b> — переключатель «Тренд и среднее» над графиком включает/выключает тренды для всех метрик одновременно. Рядом в выпадающем списке выбирается тип тренда по умолчанию.
<br><br>
2. <b>Индивидуальная настройка</b> — нажмите «...» в заголовке любой метрики в таблице. В секции «Тренд и среднее» можно выбрать свой тип тренда для каждой метрики, отличающийся от глобального.
<br><br>
3. <b>Отключение для отдельной метрики</b> — нажмите на активную кнопку тренда в поповере метрики или на инлайн-кнопку тренда под заголовком — тренд этой метрики отключится, остальные продолжат отображаться.
<br><br>
4. <b>Сброс настроек</b> — при повторном включении глобального переключателя все индивидуальные настройки сбрасываются, и метрики снова следуют общему типу тренда.
<br><br>
<b>Тренды доступны только для линейных и area-графиков.</b>
`;

export const reportDescription = `Это самый основной отчёт в сервисе SCAN, который позволяет увидеть эффективность воронки в разных разрезах регистраций и с разными условиями и сегментами пользователей.
 <br> <a href="https://help.scananalytics.ru/?p=309" rel="noopener noreferrer" target="_blank">Подробнее об отчёте</a>. <br><br>
 Как создавать, сохранять и работать с сотнями отчётов описано <a href="https://help.scananalytics.ru/?p=462" rel="noopener noreferrer" target="_blank">здесь</a>.
`;
